import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    padding: '0px 24px',
    width: '100%',
    height: theme.settings.size.desktop.menuHeight,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0px 2px 2px rgba(50, 50, 71, 0.06), 0px 2px 4px rgba(50, 50, 71, 0.06)',
    position: 'relative',
    zIndex: 100,
  },
  menuItems: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
  },
  menuItem: {
    margin: '0px 16px',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    color: 'red',
    '&:focus': {
      textDecoration: 'none',
    },
  },
  menuItemActive: {
    borderBottom: `4px solid ${theme.palette.colors.red}`,
    paddingTop: '4px',
  },
  userBar: {
    display: 'flex',
  },
  userLabel: {
    width: '100%',
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: 16,
  },
  displayName: {
    borderBottom: '1px dashed #000000',
    marginBottom: 6,
  },
  popupMenuItem: {
    minWidth: 200,
  },
}));



// WEBPACK FOOTER //
// ./src/layouts/AppLayout/components/Menu/components/DesktopMenu/useStyles.js